import { render, staticRenderFns } from "./NavProfileMenu.vue?vue&type=template&id=086019a5&scoped=true&"
import script from "./NavProfileMenu.vue?vue&type=script&lang=ts&"
export * from "./NavProfileMenu.vue?vue&type=script&lang=ts&"
import style0 from "./NavProfileMenu.vue?vue&type=style&index=0&id=086019a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086019a5",
  null
  
)

export default component.exports